import { Pagination } from "src/shared/model/pagination";
import { action } from "typesafe-actions";
import { IAdminNotice, AdminNoticeActionType } from "./types";

export function adminNoticeFetchData(notices: Pagination<IAdminNotice>) {
    return action(AdminNoticeActionType.FETCH_ADMIN_NOTICE, { notices })
}

export function adminNoticeStateChanged(state: boolean) {
    return action(AdminNoticeActionType.NOTICE_STATE_CHANGED, { state })
}

export function systemNoticeFetchData(systemNotices: Pagination<IAdminNotice>) {
    return action(AdminNoticeActionType.FETCH_SYSTEM_NOTICE, { systemNotices })
}

export function systemNoticeStateChanged(systemState: boolean) {
    return action(AdminNoticeActionType.SYSTEM_NOTICE_STATE_CHANGED, { systemState })
}